var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"more-info"},[(_vm.obj.contacts.length > 0)?_c('div',{staticClass:"items"},[_c('img',{attrs:{"src":require("../assets/imgs/10/now.png"),"alt":""},on:{"click":_vm.call}})]):_vm._e(),(
      _vm.obj.processingMethod === 1 ||
      _vm.obj.processingMethod === 2 ||
      _vm.obj.processingMethod === 3
    )?_c('div',{staticClass:"items"},[_c('img',{attrs:{"src":require("../assets/imgs/10/call.png"),"alt":""},on:{"click":_vm.now}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }